import { camelCase, kebabCase, snakeCase, startCase } from 'lodash-es';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/ar';

export abstract class GStatic {
  public static myProp = 'Hello';

  public static doSomething(): string {
    return 'World';
  }

  // Console Log
  public static log(...args): void {
    if (!environment.production && false) {
      args[0] = '%c' + args[0];
      args.splice(1, 0, 'background: #222; color: #bada55');
      console.log(...args);
    }
  }

  public static transformDate(
    value: any,
    inputFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
    dateOnly: boolean = false,
    dateWithTime: boolean = false,
  ): string {
    let formattedDate = GStatic.defaultDateFormat(value);
    if (formattedDate !== 'Invalid date' && value !== null) {
      const timeZone = moment.tz.guess(); // Get the current time zone of the browser

      const localFormattedDate = moment.utc(formattedDate).tz(timeZone);

      const finalFormattedDate = localFormattedDate['_i'];

      // formattedDate = moment
      //   .utc(formattedDate)
      //   .tz(timeZone)
      //   .format('YYYY-MM-DD hh:mm:ss A');

      const date = finalFormattedDate.split(' ')[0];
      const time = finalFormattedDate.split(' ')[1];
      let ampm = finalFormattedDate.split(' ')[2];
      if (localStorage.getItem('lang') === 'ar') {
        ampm = ampm === 'am' ? 'ص' : 'م';
      }
      if (!dateOnly && !dateWithTime) {
        return date + ' <small class="whitespace-nowrap">' + time + ' ' + ampm + '</small>';
      }
      if (dateOnly) {
        return date;
      }
      if (dateWithTime) {
        return date + ' ' + time + ' ' + ampm;
      }
    } else {
      return localStorage.getItem('lang') === 'ar' ? 'غير محدد' : 'N/A';
    }
  }

  public static logImp(...args): void {
    if (!environment.production) {
      args[0] = '%c' + args[0];
      args.splice(1, 0, 'background: #991010; color: #ddd');
      console.log(...args);
    }
  }

  // String Handling
  public static strToCamelCase(str): string {
    return camelCase(str);
  }

  public static strToKebabCase(str): string {
    return kebabCase(str);
  }

  public static strToSnakeCase(str): string {
    return snakeCase(str);
  }

  public static strToNormalCase(str): string {
    return startCase(str);
  }

  public static isMobile(): boolean {
    const ua = window.navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
      ua,
    );
  }

  public static defaultDateFormat(
    dateObj: any,
    inputFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
    outputFormat: string = 'YYYY-MM-DD hh:mm a',
    locale?: 'ar' | 'en' | 'ru',
  ): string {
    // Use current UI language so AM/PM matches language (fixes Arabic "م" showing when lang is English)
    const currentLang = locale ?? localStorage.getItem('lang') ?? 'en';
    const momentLocale = currentLang === 'ar' ? 'ar' : currentLang === 'ru' ? 'ru' : 'en';
    // Russian uses 24-hour format — no AM/PM
    const effectiveFormat =
      currentLang === 'ru'
        ? outputFormat.replace('hh:mm a', 'HH:mm').replace('h:mm a', 'H:mm')
        : outputFormat;
    const timeZone = moment.tz.guess();
    return moment
      .utc(dateObj, inputFormat)
      .tz(timeZone)
      .locale(momentLocale)
      .format(effectiveFormat);
  }

  public static dateFromNow(
    dateObj: any,
    inputFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
    timeZone = moment.tz.guess(),
  ): string {
    const momentObj = moment.utc(dateObj, inputFormat).tz(timeZone);
    const lang = localStorage.getItem('lang') || 'en';
    return momentObj.locale(lang).fromNow();
  }

  public static animate(
    from: number = 0,
    to: number = 300,
    fun: (x: number) => void,
    duration: number = 500,
    timerInterval1?: any,
  ): ReturnType<typeof setTimeout> {
    clearInterval(timerInterval1);
    const easeInOutQuart = (t, b, c, d) => {
      // eslint-disable-next-line no-cond-assign
      if ((t /= d / 2) < 1) {
        return (c / 2) * t * t * t * t + b;
      }
      return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
    };

    const start = new Date().getTime();
    const timerInterval = setInterval(() => {
      const time = new Date().getTime() - start;
      const x = easeInOutQuart(time, from, to - from, duration);
      fun(x);
      if (time >= duration) {
        clearInterval(timerInterval);
        fun(to);
      }
    }, 1000 / 60);

    return timerInterval;
  }

  public static capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
